<template>
  <Modal>
    <template v-slot:header>
      <h2>Må vi passe på dine data?</h2>
    </template>

    <div>
      <p>Hvis du accepterer opbevarer vi dit navn, din e-mail, samt de oplysninger du indtaster... </p>
      <ul>
        <li>i forbindelse med oprettelse og anvendelse af ruter</li>
        <li>i dine personlige indstillinger</li>
      </ul>
      <p>Læs og acceptér vores <a @click="showMore = true" href="#">privatlivspolitik</a>, for at bruge Tripply.</p>
    </div>

    <template v-slot:footer>
      <AppButton @click="accept()" color="primary">Jeg accepterer</AppButton>
    </template>

    <Modal v-model="showMore" closable wide>
      <template v-slot:header>
        <h2>Cookie- og privatlivspolitik</h2>
      </template>
      <PrivacyPage />
      <template v-slot:footer>
       <AppButton @click="showMore = false" color="primary">Luk</AppButton>
      </template>
    </Modal>

  </Modal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { store } from '@/store'
import PrivacyPage from '@/views/pages/Privacy.vue'

export default defineComponent({
  props: {
    routeId: String
  },
  components: { PrivacyPage },
  name: 'PrivacyConsent',
  setup() {

    const showMore = ref(false)

    function accept() {
      store.user.acceptPrivacy()
      store.modal.hideModal('PrivacyConsent')
    }
    
    return { accept, showMore }
  }
})
</script>

<style>

</style>